// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__1Te0M","tab-item":"Tab_tab-item__38Y_O","is-active":"Tab_is-active__2thIu"};